import React from 'react';
import {theme} from 'antd';

const {useToken} = theme;

const HelixConnectivityNullIcon = ({
                                         width = 32,
                                         height = 32,
                                         ...rest
                                     }: {
    width?: number;
    height?: number;
    [x: string]: unknown;
}) => {
    const {token} = useToken();
    return (
        <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <rect width="32" height="32" rx="16"  fill={token.colorBgContainer} />
            <path
                d="M22 13C22 15.6728 19.7059 17.8853 16.75 18.2087V19C16.75 19.1989 16.671 19.3897 16.5303 19.5303C16.3897 19.671 16.1989 19.75 16 19.75C15.8011 19.75 15.6103 19.671 15.4697 19.5303C15.329 19.3897 15.25 19.1989 15.25 19V17.5C15.25 17.3011 15.329 17.1103 15.4697 16.9697C15.6103 16.829 15.8011 16.75 16 16.75C18.4816 16.75 20.5 15.0681 20.5 13C20.5 10.9319 18.4816 9.25 16 9.25C13.5184 9.25 11.5 10.9319 11.5 13C11.5 13.1989 11.421 13.3897 11.2803 13.5303C11.1397 13.671 10.9489 13.75 10.75 13.75C10.5511 13.75 10.3603 13.671 10.2197 13.5303C10.079 13.3897 10 13.1989 10 13C10 10.105 12.6916 7.75 16 7.75C19.3084 7.75 22 10.105 22 13ZM16 22C15.7033 22 15.4133 22.088 15.1666 22.2528C14.92 22.4176 14.7277 22.6519 14.6142 22.926C14.5006 23.2001 14.4709 23.5017 14.5288 23.7926C14.5867 24.0836 14.7296 24.3509 14.9393 24.5607C15.1491 24.7704 15.4164 24.9133 15.7074 24.9712C15.9983 25.0291 16.2999 24.9994 16.574 24.8858C16.8481 24.7723 17.0824 24.58 17.2472 24.3334C17.412 24.0867 17.5 23.7967 17.5 23.5C17.5 23.1022 17.342 22.7206 17.0607 22.4393C16.7794 22.158 16.3978 22 16 22Z"
                fill={token.colorIcon}/>
        </svg>
    );
};

export default HelixConnectivityNullIcon;
